export const categoryEnum = [
  {
    text: 'Seçim Yapınız',
    value: '0',
  },
  {
    text: 'Atolye',
    value: 'atolye',
  },
  {
    text: 'Çoçuk Etkinlikleri',
    value: 'cocuk-etkinlikleri',
  },
  {
    text: 'Konser',
    value: 'konser',
  },
  {
    text: 'Opera Bale',
    value: 'opera-bale',
  },
  {
    text: 'Sergi',
    value: 'sergi',
  },
  {
    text: 'Sinema',
    value: 'sinema',
  },
  {
    text: 'Söyleşi',
    value: 'soylesi',
  },
  {
    text: 'Tiyatro Müzikal',
    value: 'tiyatro-muzikal',
  },
  {
    text: 'Etkinlik Önerileri',
    value: 'etkinlikler',
  },
]
